let doit;

const adjustIcon = () => {
  const departments = document.getElementsByClassName('department');
  const members = document.getElementsByClassName('member');

  for (let i = 0, l = members.length; i < l; i++) {
    const rect = members[i].getBoundingClientRect();
    departments[i].style.position = 'fixed';
    departments[i].style.zIndex = 1;
    departments[i].style.left = rect.x + 'px';
    departments[i].style.top = rect.y + 'px';
  }
};

const clearSet = () => {
  clearTimeout(doit);

  doit = setTimeout(() => {
    adjustIcon();
  }, 10);
};

window.addEventListener('resize', () => {
  clearSet();
}, false);

window.addEventListener('scroll', () => {
  clearSet();
}, false);

window.addEventListener('load', () => {
  clearSet();
}, false);

